var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item),expression:"item"}],attrs:{"type":"text","placeholder":_vm.$t('services.inventory.compartment-seat-numbers')},domProps:{"value":(_vm.item)},on:{"input":function($event){if($event.target.composing){ return; }_vm.item=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cb7d0ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/layout/Seats.vue
// module id = null
// module chunks = 